import * as React from 'react'
import MuiAvatar from '@mui/material/Avatar'

export default function Avatar({
  src, alt, size = 'md', ...props
}){
  if (size in Avatar.SIZES) size = Avatar.SIZES[size]
  let nameParts = (alt || '? ?').split(' ')

  return <MuiAvatar {...{
    ...props,
    src,
    sx: {
      display: 'inline-flex',
      width: size,
      height: size,
      fontSize: (size / 2),
      ...props.sx
    }
  }}>
    {src ?? `${nameParts[0][0]}${nameParts[1] ? nameParts[1][0] : ''}`}
  </MuiAvatar>
}

Avatar.SIZES = {
  sm: 25,
  md: 50,
  lg: 100,
  xl: 150,
}
